import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { Resume } from './pages/Resume'
import { Portfolio } from './pages/Portfolio'
import { Blog } from './pages/Blog'
import { BlogPost } from './pages/BlogPost'
import { About } from './pages/About'
import { Contact } from './pages/Contact'
import { FugueLab } from './pages/FugueLab'
import { CompanyLanding } from './pages/CompanyLanding'
import { NotFound } from './pages/NotFound'
import { useLenis } from '@/hooks'

function App() {
  // Initialize smooth scrolling
  useLenis()

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/fugue-lab" element={<FugueLab />} />
        <Route path="/for/:companyId" element={<CompanyLanding />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
